import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import ReferralsView from "../../../../user/ReferralsView.tsx";

export const Route = createFileRoute('/_app/profiles/$player_uid/referrals')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ReferralsView />
}
